/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as AppClaimsRouteImport } from './routes/_app/claims'
import { Route as AppConnectionsRouteImport } from './routes/_app/connections'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDemandRouteImport } from './routes/_app/demand'
import { Route as AppFulfillmentRouteImport } from './routes/_app/fulfillment'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppListingsRouteImport } from './routes/_app/listings'
import { Route as AppMessagesRouteImport } from './routes/_app/messages'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppProfitRouteImport } from './routes/_app/profit'
import { Route as AppPurchasesRouteImport } from './routes/_app/purchases'
import { Route as AppQuestionsRouteImport } from './routes/_app/questions'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSetupRouteImport } from './routes/_app/setup'
import { Route as AppStockRouteImport } from './routes/_app/stock'
import { Route as AppConnectionsInboundRouteImport } from './routes/_app/connections_.inbound'
import { Route as AppConnectionsOutboundRouteImport } from './routes/_app/connections_.outbound'
import { Route as AppListingsIdRouteImport } from './routes/_app/listings_.$id'
import { Route as AppOrdersIdRouteImport } from './routes/_app/orders_.$id'
import { Route as AppStockIdRouteImport } from './routes/_app/stock_.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppClaimsRoute = AppClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectionsRoute = AppConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDemandRoute = AppDemandRouteImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => AppRoute,
} as any)
const AppFulfillmentRoute = AppFulfillmentRouteImport.update({
  id: '/fulfillment',
  path: '/fulfillment',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppListingsRoute = AppListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppProfitRoute = AppProfitRouteImport.update({
  id: '/profit',
  path: '/profit',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasesRoute = AppPurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => AppRoute,
} as any)
const AppQuestionsRoute = AppQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppStockRoute = AppStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectionsInboundRoute = AppConnectionsInboundRouteImport.update({
  id: '/connections_/inbound',
  path: '/connections/inbound',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectionsOutboundRoute = AppConnectionsOutboundRouteImport.update({
  id: '/connections_/outbound',
  path: '/connections/outbound',
  getParentRoute: () => AppRoute,
} as any)
const AppListingsIdRoute = AppListingsIdRouteImport.update({
  id: '/listings_/$id',
  path: '/listings/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIdRoute = AppOrdersIdRouteImport.update({
  id: '/orders_/$id',
  path: '/orders/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppStockIdRoute = AppStockIdRouteImport.update({
  id: '/stock_/$id',
  path: '/stock/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/activity': typeof AppActivityRoute
  '/billing': typeof AppBillingRoute
  '/claims': typeof AppClaimsRoute
  '/connections': typeof AppConnectionsRoute
  '/dashboard': typeof AppDashboardRoute
  '/demand': typeof AppDemandRoute
  '/fulfillment': typeof AppFulfillmentRoute
  '/home': typeof AppHomeRoute
  '/listings': typeof AppListingsRoute
  '/messages': typeof AppMessagesRoute
  '/orders': typeof AppOrdersRoute
  '/profit': typeof AppProfitRoute
  '/purchases': typeof AppPurchasesRoute
  '/questions': typeof AppQuestionsRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/stock': typeof AppStockRoute
  '/connections/inbound': typeof AppConnectionsInboundRoute
  '/connections/outbound': typeof AppConnectionsOutboundRoute
  '/listings/$id': typeof AppListingsIdRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/stock/$id': typeof AppStockIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/activity': typeof AppActivityRoute
  '/billing': typeof AppBillingRoute
  '/claims': typeof AppClaimsRoute
  '/connections': typeof AppConnectionsRoute
  '/dashboard': typeof AppDashboardRoute
  '/demand': typeof AppDemandRoute
  '/fulfillment': typeof AppFulfillmentRoute
  '/home': typeof AppHomeRoute
  '/listings': typeof AppListingsRoute
  '/messages': typeof AppMessagesRoute
  '/orders': typeof AppOrdersRoute
  '/profit': typeof AppProfitRoute
  '/purchases': typeof AppPurchasesRoute
  '/questions': typeof AppQuestionsRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/stock': typeof AppStockRoute
  '/connections/inbound': typeof AppConnectionsInboundRoute
  '/connections/outbound': typeof AppConnectionsOutboundRoute
  '/listings/$id': typeof AppListingsIdRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/stock/$id': typeof AppStockIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/claims': typeof AppClaimsRoute
  '/_app/connections': typeof AppConnectionsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/demand': typeof AppDemandRoute
  '/_app/fulfillment': typeof AppFulfillmentRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/listings': typeof AppListingsRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/profit': typeof AppProfitRoute
  '/_app/purchases': typeof AppPurchasesRoute
  '/_app/questions': typeof AppQuestionsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/setup': typeof AppSetupRoute
  '/_app/stock': typeof AppStockRoute
  '/_app/connections_/inbound': typeof AppConnectionsInboundRoute
  '/_app/connections_/outbound': typeof AppConnectionsOutboundRoute
  '/_app/listings_/$id': typeof AppListingsIdRoute
  '/_app/orders_/$id': typeof AppOrdersIdRoute
  '/_app/stock_/$id': typeof AppStockIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/activity'
    | '/billing'
    | '/claims'
    | '/connections'
    | '/dashboard'
    | '/demand'
    | '/fulfillment'
    | '/home'
    | '/listings'
    | '/messages'
    | '/orders'
    | '/profit'
    | '/purchases'
    | '/questions'
    | '/settings'
    | '/setup'
    | '/stock'
    | '/connections/inbound'
    | '/connections/outbound'
    | '/listings/$id'
    | '/orders/$id'
    | '/stock/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/activity'
    | '/billing'
    | '/claims'
    | '/connections'
    | '/dashboard'
    | '/demand'
    | '/fulfillment'
    | '/home'
    | '/listings'
    | '/messages'
    | '/orders'
    | '/profit'
    | '/purchases'
    | '/questions'
    | '/settings'
    | '/setup'
    | '/stock'
    | '/connections/inbound'
    | '/connections/outbound'
    | '/listings/$id'
    | '/orders/$id'
    | '/stock/$id'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/_app/activity'
    | '/_app/billing'
    | '/_app/claims'
    | '/_app/connections'
    | '/_app/dashboard'
    | '/_app/demand'
    | '/_app/fulfillment'
    | '/_app/home'
    | '/_app/listings'
    | '/_app/messages'
    | '/_app/orders'
    | '/_app/profit'
    | '/_app/purchases'
    | '/_app/questions'
    | '/_app/settings'
    | '/_app/setup'
    | '/_app/stock'
    | '/_app/connections_/inbound'
    | '/_app/connections_/outbound'
    | '/_app/listings_/$id'
    | '/_app/orders_/$id'
    | '/_app/stock_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/claims': {
      id: '/_app/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AppClaimsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connections': {
      id: '/_app/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof AppConnectionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/demand': {
      id: '/_app/demand'
      path: '/demand'
      fullPath: '/demand'
      preLoaderRoute: typeof AppDemandRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fulfillment': {
      id: '/_app/fulfillment'
      path: '/fulfillment'
      fullPath: '/fulfillment'
      preLoaderRoute: typeof AppFulfillmentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/listings': {
      id: '/_app/listings'
      path: '/listings'
      fullPath: '/listings'
      preLoaderRoute: typeof AppListingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profit': {
      id: '/_app/profit'
      path: '/profit'
      fullPath: '/profit'
      preLoaderRoute: typeof AppProfitRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchases': {
      id: '/_app/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof AppPurchasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/questions': {
      id: '/_app/questions'
      path: '/questions'
      fullPath: '/questions'
      preLoaderRoute: typeof AppQuestionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock': {
      id: '/_app/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof AppStockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connections_/inbound': {
      id: '/_app/connections_/inbound'
      path: '/connections/inbound'
      fullPath: '/connections/inbound'
      preLoaderRoute: typeof AppConnectionsInboundRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connections_/outbound': {
      id: '/_app/connections_/outbound'
      path: '/connections/outbound'
      fullPath: '/connections/outbound'
      preLoaderRoute: typeof AppConnectionsOutboundRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/listings_/$id': {
      id: '/_app/listings_/$id'
      path: '/listings/$id'
      fullPath: '/listings/$id'
      preLoaderRoute: typeof AppListingsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders_/$id': {
      id: '/_app/orders_/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof AppOrdersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock_/$id': {
      id: '/_app/stock_/$id'
      path: '/stock/$id'
      fullPath: '/stock/$id'
      preLoaderRoute: typeof AppStockIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppBillingRoute: typeof AppBillingRoute
  AppClaimsRoute: typeof AppClaimsRoute
  AppConnectionsRoute: typeof AppConnectionsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDemandRoute: typeof AppDemandRoute
  AppFulfillmentRoute: typeof AppFulfillmentRoute
  AppHomeRoute: typeof AppHomeRoute
  AppListingsRoute: typeof AppListingsRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppProfitRoute: typeof AppProfitRoute
  AppPurchasesRoute: typeof AppPurchasesRoute
  AppQuestionsRoute: typeof AppQuestionsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSetupRoute: typeof AppSetupRoute
  AppStockRoute: typeof AppStockRoute
  AppConnectionsInboundRoute: typeof AppConnectionsInboundRoute
  AppConnectionsOutboundRoute: typeof AppConnectionsOutboundRoute
  AppListingsIdRoute: typeof AppListingsIdRoute
  AppOrdersIdRoute: typeof AppOrdersIdRoute
  AppStockIdRoute: typeof AppStockIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppBillingRoute: AppBillingRoute,
  AppClaimsRoute: AppClaimsRoute,
  AppConnectionsRoute: AppConnectionsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDemandRoute: AppDemandRoute,
  AppFulfillmentRoute: AppFulfillmentRoute,
  AppHomeRoute: AppHomeRoute,
  AppListingsRoute: AppListingsRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppProfitRoute: AppProfitRoute,
  AppPurchasesRoute: AppPurchasesRoute,
  AppQuestionsRoute: AppQuestionsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSetupRoute: AppSetupRoute,
  AppStockRoute: AppStockRoute,
  AppConnectionsInboundRoute: AppConnectionsInboundRoute,
  AppConnectionsOutboundRoute: AppConnectionsOutboundRoute,
  AppListingsIdRoute: AppListingsIdRoute,
  AppOrdersIdRoute: AppOrdersIdRoute,
  AppStockIdRoute: AppStockIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
